import load from 'load-script'
import loadcss from 'xp-loadcss'
import EventEmitter from 'events'
const ee = new EventEmitter()
const externalModuleMap = {
  'vue-quill-editor': {
    // string or [string]
    js: [
      'https://unpkg.com/quill@1.3.6/dist/quill.min.js',
      'https://unpkg.com/vue-quill-editor@3.0.6/dist/vue-quill-editor.js',
      'https://unpkg.com/quill-mention@3.1.0/dist/quill.mention.min.js',
      'https://unpkg.com/quill-image-resize-module@3.0.0/image-resize.min.js',
    ],
    css: [
      'https://unpkg.com/quill@1.3.6/dist/quill.snow.css',
      // 'https://unpkg.com/quill-mention@3.1.0/dist/quill.mention.min.css',
    ],
  },
}

const loadInfoMap = {}
export const loadScript = function(js) {
  return new Promise((resolve, reject) => {
    load(js, function(err, script) {
      if (err) {
        reject(err)
      } else {
        resolve()
      }
    })
  })
}

export const loadModule = function(moduleName) {
  return new Promise(async (resolve, reject) => {
    const module = externalModuleMap[moduleName]
    if (module) {
      if (loadInfoMap[moduleName]) {
        if (loadInfoMap[moduleName] === 'LOADING') {
          ee.once(`LOAD_SCRIPT_${moduleName}`, function(err) {
            if (err) {
              reject(err)
            } else {
              resolve()
            }
          })
        }
        if (loadInfoMap[moduleName] === 'LOADED') {
          resolve()
        }
      } else {
        loadInfoMap[moduleName] = 'LOADING'
        // 不关心css 的加载是否完成
        if (module.css) {
          const css = module.css
          loadcss(css)
        }
        try {
          const jsList = []
          if (module.js) {
            if (typeof module.js === 'string') {
              jsList.push(module.js)
            } else {
              module.js.map(js => {
                jsList.push(js)
              })
            }
          }
          for (let i = 0; i < jsList.length; i++) {
            await loadScript(jsList[i])
          }
          loadInfoMap[moduleName] = 'LOADED'
          ee.emit(`LOAD_SCRIPT_${moduleName}`)
          resolve()
        } catch (e) {
          ee.emit(`LOAD_SCRIPT_${moduleName}`, e)
          reject(e)
        }
      }
    } else {
      reject(new Error(`Error loadModule:moduleName "${moduleName}" not defined in externalModuleMap`))
    }
  })
}
export const loadImage = function(images) {
  let promiseAll = [],
    imgs = [],
    total = images.length
  for (let i = 0; i < total; i++) {
    promiseAll[i] = new Promise((resolve, reject) => {
      imgs[i] = new Image()
      imgs[i].src = images[i]
      imgs[i].onload = function() {
        resolve(imgs[i])
      }
      imgs[i].onerror = function(e) {
        reject(e)
      }
    })
  }
  return Promise.all(promiseAll)
}
